// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenHeaderAction_root"};